import React from "react";

const DetailPage = () => {
  return <div>detail page</div>;
};

export default DetailPage;
